// extracted by css-extract-rspack-plugin
export default {"roomTypeContainerFilterSubsection":"roomType-module__roomTypeContainerFilterSubsection"};